import { lazy, Suspense } from "react";

const TransactlyApp = lazy(() => import(/* rspackChunkName: "transactly-app" */ "./TransactlyApp"));

const TransactlyLazy = ({
  okta_base_url: oktaBaseUrl,
  okta_client_id: oktaClientId,
}: {
  okta_base_url: string;
  okta_client_id: string;
}) => (
  <Suspense fallback={null}>
    <TransactlyApp oktaBaseUrl={oktaBaseUrl} oktaClientId={oktaClientId} />
  </Suspense>
);

export default TransactlyLazy;
